import { useEffect } from 'react'

const TITLE = 'Rituales y Orientación Espiritual | Templo de Ayuda'
const DESCRIPTION =
  'Consultas y prácticas tradicionales de brujería, hechicería, tarot y chamanismo, realizadas de manera personalizada. Servicio exclusivo para mayores de edad.'

/** Fija el título y la descripción visibles de la página. */
export function useDocumentMeta(): void {
  useEffect(() => {
    document.title = TITLE

    let meta = document.querySelector<HTMLMetaElement>(
      'meta[name="description"]',
    )
    if (!meta) {
      meta = document.createElement('meta')
      meta.name = 'description'
      document.head.appendChild(meta)
    }
    meta.content = DESCRIPTION
  }, [])
}
